import React from 'react';
import { useEmbedFilters } from './EmbedWrapper';
import { useTeamKPIsData } from '../../hooks/useEmbedData';
import { TeamKPIsWidget } from '../widgets/TeamKPIsWidget';

const EmbedTeamKPIs: React.FC = () => {
  const filters = useEmbedFilters();
  const { teamsData, employeesTable, resourcePlanningData, isLoading, error } = useTeamKPIsData(filters);

  if (error) {
    return <div className="text-red-600 text-center py-4">Error: {error}</div>;
  }

  return (
    <TeamKPIsWidget
      teams={teamsData}
      employeesTable={employeesTable}
      resourcePlanningData={resourcePlanningData}
      isLoading={isLoading}
    />
  );
};

export default EmbedTeamKPIs;
